import { render, staticRenderFns } from "./AdminWithdrawals.vue?vue&type=template&id=0f3976c4&"
import script from "../js/admin-withdrawals.js?vue&type=script&lang=js&"
export * from "../js/admin-withdrawals.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports